import React from 'react'

const OurVision = () => {
    return (
        <div>OurVision</div>
    )
}

export default OurVision